import { UIGameBaseShoreTileController } from './UIGameShoreTileControllerBase.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameGeneralShoreTileController extends UIGameBaseShoreTileController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.MapStateUpdated:
                this.updateShoreTiles();
                break;
            default:
                break;
        }
    }
    findShoreHexes() {
        const shoreHexes = [];
        for (const tile of this.uiGameManager.gameController.mapValidator.tileState.tiles){
            if (!tile.isTileLand()) continue;
            for (const neighbor of tile.hexFace.neighbors()){
                const neighborTile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(neighbor);
                if (neighborTile === null || neighborTile === void 0 ? void 0 : neighborTile.isTileLand()) continue;
                const shoreHexesIncludesNeighbor = shoreHexes.some((face)=>face.sameFace(neighbor));
                if (shoreHexesIncludesNeighbor) continue;
                shoreHexes.push(neighbor);
            }
        }
        return shoreHexes;
    }
    findHexesAroundFog() {
        if (this.fogTileGroupStates == undefined) return [];
        const hexesAroundFogTiles = [];
        for(const fogTileGroupKey in this.fogTileGroupStates){
            const fogTileGroup = this.fogTileGroupStates[fogTileGroupKey];
            if (fogTileGroup == undefined) continue;
            for (const tileIndex of fogTileGroup.fogTileIndexes){
                const tile = this.uiGameManager.gameController.mapValidator.tileState.tiles[tileIndex];
                if (tile == undefined) continue;
                for (const neighbor of tile.hexFace.neighbors()){
                    const hexesAroundFogTilesIncludesNeighbor = hexesAroundFogTiles.some((face)=>face.sameFace(neighbor));
                    if (hexesAroundFogTilesIncludesNeighbor) continue;
                    hexesAroundFogTiles.push(neighbor);
                }
            }
        }
        return hexesAroundFogTiles;
    }
    createShoreTiles(shoreHexes) {
        for (const face of shoreHexes){
            const tile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(face);
            if (tile === null || tile === void 0 ? void 0 : tile.isTileLand()) continue;
            const data = this.getTextureAndAngle(face);
            this.createShoreTile(face, data.texture, data.angle);
        }
    }
    updateShoreTiles() {
        for (const shoreTile of this.shoreTiles){
            const tile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(shoreTile.hexFace);
            if (tile === null || tile === void 0 ? void 0 : tile.isTileLand()) continue;
            const data = this.getTextureAndAngle(shoreTile.hexFace);
            shoreTile.tileSpriteView.texture = data.texture;
            shoreTile.tileSpriteView.angle = data.angle;
        }
    }
    static getUniqueHexFaces(hexFaces) {
        const uniqueHexFaces = [];
        for (const hexFace of hexFaces){
            const hexFaceIncludes = uniqueHexFaces.some((face)=>face.sameFace(hexFace));
            if (hexFaceIncludes) continue;
            uniqueHexFaces.push(hexFace);
        }
        return uniqueHexFaces;
    }
    constructor(uiGameManager, fogTileGroupStates){
        super(uiGameManager);
        this.fogTileGroupStates = fogTileGroupStates;
        const shoreHexes = this.findShoreHexes();
        const hexesAroundFog = this.findHexesAroundFog();
        const allPotentialShoreHexes = UIGameGeneralShoreTileController.getUniqueHexFaces([
            ...shoreHexes,
            ...hexesAroundFog
        ]);
        this.createShoreTiles(allPotentialShoreHexes);
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
